$.fn.closeNotification = function () {
  $(this).each(function () {
    var $this = $(this);
    var $closeLink = $(
      '<a href="#" class="icon icon-close js-close-element">' +
        '<span class="visually-hidden">Close</span>' +
        "</a>",
    );

    $closeLink.on("click", function (e) {
      e.preventDefault();
      $this.slideUp(500, function () {
        $closeLink.remove();
        $this.remove();
      });
    });

    $this.append($closeLink);
  });

  return this;
};
